export default __webpack_public_path__ + "static/media/datahidding.f44af8ea.webp";